<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Steel Inserts';
                }
            },
            component_id: {
                default(){
                    return 'steel_inserts';
                }
            },
            slab: {
                required: true
            },
            maintitle: {
                default() {
                    return 'Select Steel Inserts';
                }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.slab);
            },
            url(){
                return '/api/options/' + this.fabricator + '/steel-inserts?slab=' + this.slab;
            },
            cache_key(){
                return '_' + this.slab;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
